import { Stack, Typography } from "@mui/material";

export const H1Component = ({ text }: { text: string }) => {
  return (
    <Stack paddingBottom="12px" borderBottom="4px solid #59BFCF">
      <Typography variant="h1" component="h2" sx={{ fontSize: "34px" }}>
        {text}
      </Typography>
    </Stack>
  );
};
